import { DELETE_INFO_TALENT_START } from '../../types';

export const delete_info_talent = (payload) => ({
  type: DELETE_INFO_TALENT_START,
  payload,
});
